import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { EPackageType } from 'src/app/micro-services/packages/enum/e-package-type';
import { PackagePlatform } from 'src/app/micro-services/packages/models/package-platform';
import { PackageFactoryService } from 'src/app/micro-services/packages/services/package-factory.service';

@Component({
  selector: 'app-form-package',
  templateUrl: './form-package.component.html',
  styleUrls: ['./form-package.component.scss'],
})
export class FormPackageComponent implements OnInit {

  packageForm : FormGroup;
  @Input() package: PackagePlatform;
  @Output() packageEvent = new EventEmitter<PackagePlatform>();
  
  constructor(
    private modalCtrl: ModalController,
    private toastController : ToastController,
    private packageFactoryService: PackageFactoryService
  ) { }

  ngOnInit() {

    if(this.package){
      this.packageForm = new FormGroup(
        {
          Name : new FormControl(this.package.name, Validators.required),
          Price : new FormControl(this.package.price, Validators.required),
          Recurrence : new FormControl(this.package.recurrence, Validators.required),
          Description : new FormControl(this.package.description, Validators.required),
          UserLimit : new FormControl(this.package.userLimit, Validators.required)
        }
      );
    }else{
      this.packageForm = new FormGroup(
        {
          Name : new FormControl('', Validators.required),
          Price : new FormControl('', Validators.required),
          Recurrence : new FormControl('', Validators.required),
          Description : new FormControl('', Validators.required),
          UserLimit : new FormControl('', Validators.required)
        }
      );
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  validate(){

    if(this.packageForm.invalid)
    {
      this.packageForm.markAllAsTouched();
      return
    }

     // MODIFICATION 
    if(this.package?.id)
    {
 
       this.packageFactoryService.create(EPackageType.Plateform).editPackage({... this.packageForm.value, discriminator : EPackageType.Plateform, id : this.package.id, stripePriceId : this.package.stripePriceId, stripeProductId : this.package.stripeProductId }).subscribe(
         (data) => {
           this.packageEvent.emit(data);
           return this.modalCtrl.dismiss(data, 'edit');
         },
         async (err) => {
           const toast = await this.toastController.create({
             message: "Erreur lors de l'edition",
             duration: 5000,
             buttons: [
               {
                 text: 'Compris',
                 role: 'cancel'
               }
             ]
           });
           await toast.present();
         }
       );
 
    }else{
       // CREATION 
      this.packageFactoryService.create(EPackageType.Plateform).createPackage({... this.packageForm.value, Discriminator : EPackageType.Plateform }).subscribe(
        (data) => {
          this.packageEvent.emit(data);
          return this.modalCtrl.dismiss(data, 'create');
        },
        async (err) => {
          const toast = await this.toastController.create({
            message: 'Erreur lors de la creation',
            duration: 5000,
            buttons: [
              {
                text: 'Compris',
                role: 'cancel'
              }
            ]
          });
          await toast.present();
        }
      );
    }
  }
}

